import customAxios from "./axiosConfig";

const DashboardService = {

  // team invites
  acceptInvitation (invite_id) {
    const api_url = window.Urls['userinvite_accept'](invite_id)
    return customAxios.post(api_url);
  },
  rejectInvitation (invite_id) {
    const api_url = window.Urls['userinvite_reject'](invite_id)
    return customAxios.delete(api_url);
  },
  // freelancer/accountant invites
  getFreelancerInvite (invite_id) {
    const api_url = window.Urls['freelancerinvite_detail'](invite_id)
    return customAxios.get(api_url);
  },
  acceptAccountantInvitation (payload) {
    const api_url = window.Urls['freelancerinvite_accept'](payload.invite_id)
    return customAxios.post(api_url, payload.params);
  },
  rejectAccountantInvitation (invite_id) {
    const api_url = window.Urls['freelancerinvite_reject'](invite_id)
    return customAxios.delete(api_url);
  },
  // Notifications
  toggleSeenUnseen (notification_id) {
    const api_url = window.Urls['timelineentry_toggle_seen_unseen'](notification_id)
    return customAxios.post(api_url);
  },
  getGekkoNotification (notification_id) {
    const api_url = window.Urls["gekkonotification_detail"](notification_id)
    return customAxios.get(api_url);
  },

  // Account timeline
  activitiesTimeline (params) {
    const api_url = window.Urls['timelineentry_list']()
    return customAxios.get(api_url, { params: params });
  },
  moreActivities (url) {
    return customAxios.get(url);
  },
  getTimeentryCount (params) {
    const api_url = window.Urls['timelineentry_count']()
    return customAxios.get(api_url, { params: params });
  },

  // App preview cost/hours/trips/invoices
  appPreviewCosts (params) {
    const api_url = window.Urls['v3:cost_totals']()
    return customAxios.get(api_url, { params: params });
  },
  appPreviewHours (params) {
    const api_url = window.Urls['v4:timeentry-totals']()
    return customAxios.get(api_url, { params: params });
  },
  appPreviewInvoices (params) {
    const api_url = window.Urls['invoice_totals']()
    return customAxios.get(api_url, { params: params });
  },
  appPreviewTrips (params) {
    const api_url = window.Urls['v3:trip_totals']()
    return customAxios.get(api_url, { params: params });
  },
  
  // Available users
  availableUsers (params) {
    const api_url = window.Urls['company-owner-list']()
    return customAxios.get(api_url, { params: params });
  },
  
  // Chart apis
  financiallyActiveYears (company_id) {
    const api_url = window.Urls["company_profile_financially_active_years"](company_id)
    return customAxios.get(api_url);
  },
  invoicesTotalNet (params) {
    const api_url = window.Urls['invoice_total_net']()
    return customAxios.get(api_url, { params: params });
  },
  costsTotalNet (params) {
    const api_url = window.Urls['cost_total_net']()
    return customAxios.get(api_url, { params: params });
  },

  // Last 30 days - Extra chart data
  invoicePaymentsTotal (params) {
    // start_date                     -> 2022-02-22
    // end_date                       -> 2022-03-24
    // group_by                       -> payment_type
    // invoice__sender_company        -> window.company_id
    // invoice_status                 -> p,s
    
    const api_url = window.Urls['invoicepayment_total']()
    return customAxios.get(api_url, { params: params });
  },
  costsTotal (params) {
    // start_date                     -> 2022-02-22
    // end_date                       -> 2022-03-24
    // group_by                       -> payment_type
    // owner_company                  -> window.company_id
    
    const api_url = window.Urls['cost_total']()
    return customAxios.get(api_url, { params: params });
  },

  // Coming up - Extra chart data
  getComingUp (params) {
    // sender_company                 -> window.company_id
    const api_url = window.Urls['invoice_coming_up']()
    return customAxios.get(api_url, { params: params });
  },
  discountForUser (params) {
    const api_url = window.Urls['discount-dashboard-discount-for-user']();
    return customAxios.get(api_url, { params: params });
  }
};

export default DashboardService;